import { memo } from 'react';
import { cn } from '@divlab/divanui';
import { useInView } from 'react-intersection-observer';

import Img from '@UI/Img';
import styles from './SynchronousSchemes.module.css';

import type { Orientation } from '@Types/Base';
import type { AdditionalImage } from '@Pages/PageProduct';
import type { CSSProperties, FC, HTMLAttributes } from 'react';

export interface SynchronousSchemesProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  images: AdditionalImage[];
  view: Orientation;
}

const SynchronousSchemes: FC<SynchronousSchemesProps> = (props) => {
  const { className, images, view, ...restProps } = props;
  const [ref, inView] = useInView({ rootMargin: '100px 0px', triggerOnce: true });
  const targetHeight = images[0].height;

  return (
    <div
      {...restProps}
      className={cn(styles.container, className)}
      style={{ '--element-height': `${targetHeight}px` } as CSSProperties}
    >
      {inView ? (
        <div
          className={cn(styles.schemes, {
            [styles.landscape]: view === 'landscape',
            [styles.portrait]: view === 'portrait',
          })}
        >
          {images.map((image) => (
            <div key={image.src} className={styles.schemeCell}>
              <Img
                alt=''
                src={image.src}
                className={styles.schemeImgWrapper}
                cnImage={styles.schemeImg}
              />
            </div>
          ))}
        </div>
      ) : (
        <div
          ref={ref}
          className={cn(styles.placeholder, {
            [styles.landscape]: view === 'landscape',
            [styles.portrait]: view === 'portrait',
          })}
        />
      )}
    </div>
  );
};

export default memo(SynchronousSchemes);
